document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('.product__description.rte');

  if (!description) return;

  /* Eliminar LI sin contenido visible */
  description.querySelectorAll('li').forEach((li) => {
    /* No tocar LI que sirven como contenedor de otra lista */
    if (li.querySelector(':scope > ul, :scope > ol')) return;

    const text = li.textContent
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const hasMedia = li.querySelector(
      'img, video, iframe, svg, picture'
    );

    if (!text && !hasMedia) {
      li.remove();
    }
  });

  /* Después de limpiar LI, eliminar listas completamente vacías */
  description.querySelectorAll('ul, ol').forEach((list) => {
    if (!list.querySelector('li')) {
      list.remove();
    }
  });
});